// this file is generated by update_shopify_store_data.py at 2026-02-23 20:28:00.245787
var courses = [
    {
        "course_id": "46300E20-04B7-E611-9821-005056B10F02",
        "course_version": 8,
        "name": "Creating Affirming Healthcare Environments for LGBTQIA+ Patients",
        "course_type": 1,
        "author_information": "Sarah Bender",
        "description": "This course focusses on sensitivity to LGBTQ patients in a hospital environment, and how to interact appropriately with these patients to ensure they receive the best patient care. This includes noticing people of various gender identities and being sensitive to their needs,  the laws around LGBTQ patient care, and other important patient care considerations. The course examines how to be allies with patients of different sexual orientations, people in transition, health factors, and also provides additional resources.",
        "learning_objectives_html": "<p>Upon completion of this course, participants will be able to:</p>\r\n<p>1) Use inclusive language and terminology when talking to and about LGBTQ patients.</p>\r\n<p>2) Identify at least 5 major health disparities impacting LGBTQ patients across the United States.</p>\r\n<p>3) Describe how to create an affirming environment in their own healthcare practice for LGBTQ patients and families. </p>\r\n<p>4) List at least two healthcare policies and/or laws that impact how practitioners interact with LGBTQ patients and families.</p>",
        "course_outline_html": "<p>This course provides a 30-minute&nbsp; online learning experience consisting of approximately 20 minutes of interactive elearning, a 10-minute video, and a final 5-question quiz for completion purposes. Activities include click-and-reveal, and drag-and-drop knowledge checks.</p>\r\n<p>Topics include:</p>\r\n<p>Creating a Welcoming Environment for LGBTQ Patients<br />\r\n\"\"To Treat Me, You Have to Know Who I Am\"\" video<br />\r\nAcronyms and Defining Sexual Orientation<br />\r\nCommon Gender Identities<br />\r\nLGBTQ Communities in the U.S.<br />\r\nBeing allies to patients, families and colleagues<br />\r\nDaily Tips<br />\r\nLaws around LGBTQ Patient Care<br />\r\nAdditional Resources</p>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "E9471268-F2DC-E611-A37D-005056B17C80",
                "course_category_name": "Cedar-Interactive: Creating a Welcoming HealthCare Environment for LGBTQIA+ Patients",
                "is_system_course_category": null
            },
            {
                "course_category_id": "37A67743-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Interactions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "ADFB6B18-D5C9-E511-82AF-005056B150D3",
                "course_category_name": "Cultural Awareness",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF875D23-03B7-E611-9821-005056B10F02",
                "course_category_name": "Cedar Interactive",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CE392C4B-03B7-E611-9821-005056B10F02",
                "course_category_name": "Cedar_Interactive - Creating a Welcoming HealthCare Environment for LGBTQIA+ Patients",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C9C5A616-40D6-EC11-80F1-005056B17FCD",
                "course_category_name": "Parent: Cedar Interactive",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];